"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Tab = _interopRequireDefault(require("./Tab.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable react/prop-types */

/* eslint-disable no-shadow */


var TabWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tab__TabWrapper",
  componentId: "sc-1kpwzbj-0"
})(["display:inline-flex;flex-direction:column;box-shadow:1px 1px 4px rgba(0,0,0,0.2);overflow:hidden;width:100%;"]);

var FlexRow = _styledComponents.default.div.withConfig({
  displayName: "Tab__FlexRow",
  componentId: "sc-1kpwzbj-1"
})(["display:flex;flex-direction:row;"]);

var TabHead = _styledComponents.default.div.withConfig({
  displayName: "Tab__TabHead",
  componentId: "sc-1kpwzbj-2"
})(["border-bottom:", ";background-color:", ";font-weight:", ";font-family:", ";padding:", " ", ";cursor:pointer;flex:1 100%;text-align:center;min-width:90px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;tab-index:0;&:hover{color:", ";background-color:", ";}"], function (props) {
  return props.isActive ? "2px solid ".concat(props.theme.colors.primary) : "2px solid ".concat(props.theme.colors.greyLightest);
}, function (props) {
  return props.isActive ? props.theme.backgroundColor.redLight : undefined;
}, function (props) {
  return props.isActive ? 'bold' : 'normal';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.tiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.backgroundColor.redLight;
});

var Tab = function Tab(props) {
  var accessible = props.accessible,
      childComponents = props.childComponents,
      customProperties = props.customProperties,
      labels = props.labels,
      selectedTab = props.selectedTab,
      setSelectedTab = props.setSelectedTab,
      theme = props.theme;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var propSelectedTab = typeof selectedTab === 'number' ? selectedTab : 0;
  var tabIndex = !accessible ? '-1' : '0';

  var _React$useState = _react.default.useState(propSelectedTab),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var tabsChildren = [];

  if (childComponents) {
    tabsChildren = (0, _toConsumableArray2.default)(childComponents);

    if (childComponents.length < labels.length) {
      for (var i = 0; i < labels.length - childComponents.length; i++) {
        tabsChildren.push( /*#__PURE__*/_react.default.createElement("div", null, "No Element provided"));
      }
    }
  } else {
    tabsChildren = [];

    for (var _i = 0; _i < labels.length; _i++) {
      tabsChildren.push( /*#__PURE__*/_react.default.createElement("div", null, "No Element provided"));
    }
  }

  var handleTabClick = function handleTabClick(index) {
    setActiveTab(index);
    if (typeof setSelectedTab === 'function') setSelectedTab(index);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(TabWrapper, customProperties, /*#__PURE__*/_react.default.createElement(FlexRow, null, labels.map(function (label, index) {
      return /*#__PURE__*/_react.default.createElement(TabHead, {
        isActive: index === activeTab,
        key: 'label'.concat(index.toString()),
        onClick: function onClick() {
          return handleTabClick(index);
        },
        tabIndex: tabIndex
      }, label);
    })), /*#__PURE__*/_react.default.createElement(FlexRow, null, tabsChildren[activeTab]));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Tab.propTypes = _Tab.default.PropTypes;
Tab.defaultProps = _Tab.default.DefaultProps;
var _default = Tab;
exports.default = _default;